import {
	createSlice,
	PayloadAction,
} from '@reduxjs/toolkit';
import {
	CompanyEventListResult,
	CompanyEventsState,
} from '@localTypes/companyEvents';

const initialState: CompanyEventsState = {};

export const companyEventsSlice = createSlice({
	initialState,
	name: 'company_events',
	reducers: {
		clearCompanyEvents: (state, action: PayloadAction<number>) => {
			const companyId = action.payload;
			delete state[companyId];
		},
		setCompanyEvents: (state, action: PayloadAction<{
			companyId: number;
			result: CompanyEventListResult['result'];
			total: number;
		}>) => {
			const {
				companyId,
				result,
				total,
			} = action.payload;
			state[companyId] = {
				isError: false,
				isLoading: false,
				result,
				total,
			};
		},
		setCompanyEventsError: (state, action: PayloadAction<{
			companyId: number;
			isError: boolean;
		}>) => {
			const {
				companyId,
				isError,
			} = action.payload;
			if (!state[companyId]) {
				state[companyId] = {
					isError: false,
					isLoading: false,
					result: [],
					total: 0,
				};
			}
			state[companyId].isError = isError;
		},
		setCompanyEventsLoading: (state, action: PayloadAction<{
			companyId: number;
			isLoading: boolean;
		}>) => {
			const {
				companyId,
				isLoading,
			} = action.payload;
			if (!state[companyId]) {
				state[companyId] = {
					isError: false,
					isLoading: false,
					result: [],
					total: 0,
				};
			}
			state[companyId].isLoading = isLoading;
		},
	},
});

export const {
	clearCompanyEvents,
	setCompanyEvents,
	setCompanyEventsError,
	setCompanyEventsLoading,
} = companyEventsSlice.actions;

export const companyEventsReducer = companyEventsSlice.reducer;
